import Radio from 'components/Form/Radio';
import {ChangeEvent, FC, useCallback} from 'react';
import {useFormContext} from 'react-hook-form';
import {t} from 'ttag';
import {isTaxTypeZero} from 'utils/tax';
import {taxTypeLabel} from 'utils/tax-label';

import {Deserializer, ModalFormField, NoUnselectedField} from '../utils';

interface Props {
    useAdvancedTaxSettings: 'unspecified' | boolean;
}
const RadioTaxType: FC<Props> = ({useAdvancedTaxSettings}) => {
    const form = useFormContext<ModalFormField>();

    const onChange = useCallback(
        (event: ChangeEvent<HTMLInputElement>) => {
            const taxTypeRadio = event.target
                .value as NoUnselectedField<'taxTypeRadio'>;

            form.clearErrors('taxTypeRadio');
            form.setValue('taxTypeRadio', taxTypeRadio);

            const taxType = Deserializer.taxType(taxTypeRadio);

            if (isTaxTypeZero(taxType)) {
                form.setValue('taxRateRadio', 'custom');
                form.setValue('customTaxRateText', '0');
                form.setValue('isTaxInclusiveRadio', 'false');
                form.clearErrors('taxRateRadio');
                form.clearErrors('customTaxRateText');
                form.clearErrors('isTaxInclusiveRadio');
            } else {
                form.clearErrors('customTaxRateText');
            }
            form.trigger('checkDuplicate');
        },
        [form],
    );

    return (
        <Radio
            label={t`Type`}
            name="taxTypeRadio"
            onChange={onChange}
            options={[
                {
                    disabled: useAdvancedTaxSettings === true,
                    label: taxTypeLabel('legacy_tax'),
                    value: 'legacy_tax',
                },
                {
                    disabled: useAdvancedTaxSettings === true,
                    label: taxTypeLabel('legacy_no_tax'),
                    value: 'legacy_no_tax',
                },
                {
                    disabled: useAdvancedTaxSettings === false,
                    label: taxTypeLabel('standard'),
                    value: 'standard',
                },
                {
                    disabled: useAdvancedTaxSettings === false,
                    label: taxTypeLabel('reduced'),
                    value: 'reduced',
                },
                {
                    disabled: useAdvancedTaxSettings === false,
                    label: taxTypeLabel('non_taxable'),
                    value: 'non_taxable',
                },
                {
                    disabled: useAdvancedTaxSettings === false,
                    label: taxTypeLabel('untaxable'),
                    value: 'untaxable',
                },
                {
                    disabled: useAdvancedTaxSettings === false,
                    label: taxTypeLabel('duty_free'),
                    value: 'duty_free',
                },
            ]}
            requiredType="hidden"
            rules={{
                required: t`Select a Type.`,
            }}
        />
    );
};

export default RadioTaxType;
